/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { find } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import withAuth from '../../hocs/withAuth';
import CardContent from './CardContent';
import { bucketWildcardTags as wildcardTags } from '../../../utils/eventConstants';

import PlayerCardWrapper from './PlayerCardWrapper';
import { titleCase } from '../../../utils/formatting';
import { getPlayerRegStatus } from '../../../utils';

const _ = { find };

const PlayerCard = props => {
    const {
        rank,
        player,
        currentDivision,
        utrType,
        menuOptions,
        menuOnSelected,
        showSeeProfileLink,
        forceCardView,
        force = {},
        addOptionsSpace,
        showDecimals,
        showClubCollegeDetails,
        showHighSchoolName,
        clubProfileViewType,
        showActionRequiredBackground,
        auth,
        showRatingNotLoggedIn,
        sendMessage,
        isCurrentMemberAdmin,
        displayCollegeRecruitingValues,
        hideRatings,
        inactive,
        optionSpaceContent,
        withdrawTag,
        ptsRank,
        showAdditionalInformation,
        isWTARankType,
        utrRankOrder,
        wtaRankOrder,
        showRegStatus,
        showPlayerPaymentStatus,
        showProjectedViewStatus,
        showPickleBallRatings = true,
        showTennisRatings = true,
        hideUtrLabel,
        filters,
        filterType,
        players,
        sortResults,
        sportTypes,
        isItGlobalSearch,
        playersDictByMemberId,
        onSelectClick,
        isSelected,
        showOrganizerViewForPTTEvent,
        eventStartUtc,
        checkGate,
        featureGates,
        'data-testid': dataTestId,
    } = props;

    const {
        id,
        playerId,
        firstName,
        lastName,
        gender,
        location,
        memberId,
        playerCollege,
        playerCollegeDetails,
        playerHighSchool,
        playerHighSchoolDetails,
        homeClub,
        age,
        descriptionShort,
        descriptionLong,
        isPro,
        studentInfo,
        addMemberLink,
        acceptanceListWildcardStateId,
    } = player;

    const playerData = {
        ...player,
        firstName: titleCase(firstName),
        lastName: titleCase(lastName),
    };

    const userLoggedIn = auth && auth.user;

    let playerDivision;
    if (player.registeredDivisions) { // v1
        playerDivision = _.find(player.registeredDivisions, { divisionId: currentDivision });
    } else if (player.divisions) { // v2
        playerDivision = _.find(player.divisions, { id: currentDivision });
    }
    const getDescription = () => {
        if (showHighSchoolName && player.highSchool) {
            return [player.highSchool];
        }
        if (location?.display) {
            return [location.display];
        }
    };

    let description = '';
    if (descriptionLong) {
        description = [descriptionLong];
    } else {
        description = getDescription() || [];
    }

    let descriptionMobile = '';
    if (descriptionShort) {
        descriptionMobile = [descriptionShort];
    } else {
        descriptionMobile = getDescription() || [];
    }

    let showWildcardTag = isCurrentMemberAdmin && acceptanceListWildcardStateId && acceptanceListWildcardStateId > 1;
    if (acceptanceListWildcardStateId && acceptanceListWildcardStateId === 4) { // special exempt
        showWildcardTag = true;
    }

    const descriptionItems = [
        ...(showWildcardTag ? [wildcardTags[acceptanceListWildcardStateId]] : []),
        ...(gender ? [gender.charAt(0)] : []),
        ...(description),
    ];

    playerData.descriptionItems = descriptionItems;

    let collegeRecruitingHighSchoolGradYear = null;

    if (studentInfo && studentInfo.graduationDate) {
        collegeRecruitingHighSchoolGradYear = studentInfo.graduationDate;
    } else if (playerHighSchoolDetails && playerHighSchoolDetails.gradYear) {
        collegeRecruitingHighSchoolGradYear = playerHighSchoolDetails.gradYear;
    }

    const descriptionItemsMobile = [
        ...(showWildcardTag ? [wildcardTags[acceptanceListWildcardStateId]] : []),
        ...(gender ? [gender.charAt(0)] : []),
        ...(displayCollegeRecruitingValues && age ? [`Age ${age}`] : []),
        ...(displayCollegeRecruitingValues && collegeRecruitingHighSchoolGradYear ? [`Grad. ${moment(collegeRecruitingHighSchoolGradYear).year().toString()}`] : []),
        ...(descriptionMobile),
    ];

    let collegeStringShort;
    let collegeStringLong;
    let highSchoolStringShort;
    let highSchoolStringLong;
    let clubCollegeDetailsMobile;

    if (playerCollege?.shortName) {
        collegeStringShort = playerCollege.shortName;
        collegeStringLong = playerCollege.displayName || playerCollege.shortName;
        if (playerCollegeDetails?.gradYear) {
            collegeStringShort += ` ('${moment(playerCollegeDetails.gradYear).format('YY')})`;
            collegeStringLong += ` ('${moment(playerCollegeDetails.gradYear).format('YY')})`;
            // if player is currently in college, show on mobile cards instead of location
            if (moment().diff(moment(playerCollegeDetails.gradYear)) < 0) {
                clubCollegeDetailsMobile = `${gender.charAt(0)} \u2022 ${playerCollege.shortName} ('${moment(playerCollegeDetails.gradYear).format('YY')})`;
            }
        }
    }
    if (playerHighSchool?.shortName) {
        highSchoolStringShort = playerHighSchool.shortName;
        highSchoolStringLong = playerHighSchool.displayName || playerHighSchool.shortName;
        if (playerHighSchoolDetails && playerHighSchoolDetails.gradYear) {
            highSchoolStringShort += ` ('${moment(playerHighSchoolDetails.gradYear).format('YY')})`;
            highSchoolStringLong += ` ('${moment(playerHighSchoolDetails.gradYear).format('YY')})`;

            // if player is currently in high school, show on mobile cards instead of location
            if (!clubCollegeDetailsMobile && moment().diff(moment(playerHighSchoolDetails.gradYear)) < 0) {
                let playerAgeAndStudentInfoGradYearString = '';

                if (displayCollegeRecruitingValues) {
                    if (age) {
                        playerAgeAndStudentInfoGradYearString += `Age ${age} \u2022 `;
                    }
                    if (studentInfo && studentInfo.graduationDate) {
                        playerAgeAndStudentInfoGradYearString += `Graduating ${moment(studentInfo.graduationDate).year().toString()} \u2022 `;
                    } else {
                        playerAgeAndStudentInfoGradYearString += `Graduating ${moment(playerHighSchoolDetails.gradYear).year().toString()} \u2022 `;
                    }
                }

                clubCollegeDetailsMobile = `${gender.charAt(0)} \u2022 ${playerAgeAndStudentInfoGradYearString}${playerHighSchool.shortName} ('${moment(playerHighSchoolDetails.gradYear).format('YY')})`;
            }
        }
    }

    const playerAgeAndClassDescription = [
        ...(displayCollegeRecruitingValues && age ? [`Age ${age}`] : []),
        ...(displayCollegeRecruitingValues && collegeRecruitingHighSchoolGradYear ? [`Graduating ${moment(collegeRecruitingHighSchoolGradYear).year().toString()}`] : []),
    ];

    const clubCollegeDetailsShort = [
        ...(homeClub ? [homeClub] : []),
        ...(collegeStringShort ? [collegeStringShort] : []),
        ...(highSchoolStringShort ? [highSchoolStringShort] : []),
    ];

    const clubCollegeDetailsLong = [
        ...(homeClub ? [homeClub] : []),
        ...(collegeStringLong ? [collegeStringLong] : []),
        ...(highSchoolStringLong ? [highSchoolStringLong] : []),
    ];

    playerData.descriptionLong = (playerAgeAndClassDescription && playerAgeAndClassDescription.length > 0) ? playerAgeAndClassDescription : clubCollegeDetailsLong;
    playerData.descriptionShort = (playerAgeAndClassDescription && playerAgeAndClassDescription.length > 0) ? playerAgeAndClassDescription : clubCollegeDetailsShort;
    playerData.clubCollegeDetailsMobile = clubCollegeDetailsMobile;
    playerData.descriptionItemsMobile = descriptionItemsMobile;

    const isCurrentUser = auth && auth.user && (auth.user.id === memberId);

    const ratingColWidthClass = (showRegStatus && !isWTARankType) ||
        (clubProfileViewType && !showRegStatus) ||
        (showClubCollegeDetails && !clubProfileViewType && !showRegStatus) ? 'col-3' : 'col-4';

    const enableMessaging = (!!sendMessage && !inactive && !showSeeProfileLink && !isCurrentUser && !!memberId &&
        ((isPro && isCurrentMemberAdmin) || !isPro));

    const regStatus = getPlayerRegStatus(playerDivision?.registrationStatusTypeId);

    return (
        <PlayerCardWrapper
            link={!showSeeProfileLink ? `/profiles/${id || playerId}` : null}
            actionRequired={showActionRequiredBackground}
            inactive={inactive}
            data-testid={dataTestId}
        >
            <CardContent
                filterType={filterType}
                players={players}
                sortResults={sortResults}
                userLoggedIn={userLoggedIn}
                sportTypes={sportTypes}
                player={playerData}
                user={userLoggedIn}
                rank={rank}
                paymentStatus={playerDivision?.paymentStatus} // TODO: can we remove this?
                paymentStatusTypeId={playerDivision?.paymentStatusTypeId}
                showPlayerPaymentStatus={showPlayerPaymentStatus}
                regStatus={regStatus.label}
                regStatusColor={regStatus.color}
                showRegStatus={showRegStatus}
                forceCard={forceCardView || force.cardView}
                ratingColWidthClass={ratingColWidthClass}
                clubProfileViewType={clubProfileViewType}
                addMemberLink={addMemberLink}
                addOptionsSpace={addOptionsSpace}
                showRatingNotLoggedIn={showRatingNotLoggedIn}
                showClubCollegeDetails={showClubCollegeDetails}
                hideRatings={hideRatings}
                enableMessaging={enableMessaging}
                utrType={utrType}
                menuOptions={menuOptions}
                optionSpaceContent={optionSpaceContent}
                withdrawTag={withdrawTag}
                inactive={inactive}
                showSeeProfileLink={showSeeProfileLink}
                onMessageClick={() => sendMessage(player)}
                onMenuSelected={menuOnSelected}
                showDecimals={showDecimals}
                isWTARankType={isWTARankType}
                wtaRankOrder={wtaRankOrder}
                utrRankOrder={utrRankOrder}
                ptsRank={ptsRank}
                showAdditionalInformation={showAdditionalInformation}
                showProjectedViewStatus={showProjectedViewStatus}
                showPickleBallRatings={showPickleBallRatings}
                showTennisRatings={showTennisRatings}
                hideUtrLabel={hideUtrLabel}
                filters={filters}
                isItGlobalSearch={isItGlobalSearch}
                playersDictByMemberId={playersDictByMemberId}
                isCurrentMemberAdmin={isCurrentMemberAdmin}
                onSelectClick={onSelectClick}
                isSelected={isSelected}
                showOrganizerViewForPTTEvent={showOrganizerViewForPTTEvent}
                eventStartUtc={eventStartUtc}
                checkGate={checkGate}
                featureGates={featureGates}
                data-testid={dataTestId}
            />
        </PlayerCardWrapper>
    );
};
PlayerCard.propTypes = {
    filters: PropTypes.instanceOf(Object),
    filterType: PropTypes.string,
    players: PropTypes.instanceOf(Array).isRequired,
    sortResults: PropTypes.func.isRequired,
    sportTypes: PropTypes.instanceOf(Object),
    onSelectClick: PropTypes.func,
    isSelected: PropTypes.bool,
    showOrganizerViewForPTTEvent: PropTypes.bool,
    eventStartUtc: PropTypes.string,
    'data-testid': PropTypes.string,
};
PlayerCard.defaultProps = {
    filters: null,
    filterType: null,
    sportTypes: {},
    onSelectClick: () => {},
    isSelected: false,
    showOrganizerViewForPTTEvent: false,
    eventStartUtc: null,
    'data-testid': null,
};

export default withAuth(PlayerCard);
